// Backend URL from environment variable or fallback to default
const backendUrl = 'https://limmekrent.hu';

// Cookie configuration
const cookieConfig = {
  expiryDays: process.env.VUE_APP_COOKIE_EXPIRY_DAYS || 365,
  analyticsCookieName: process.env.VUE_APP_ANALYTICS_COOKIE_NAME || 'analyticsCookies',
  requiredCookieName: process.env.VUE_APP_REQUIRED_COOKIE_NAME || 'requiredCookies',
  thirdPartyCookieName: process.env.VUE_APP_THIRD_PARTY_COOKIE_NAME || 'thirdPartyCookies'
};

// Analytics configuration
const analyticsConfig = {
  googleAnalyticsId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID || '',
  facebookPixelId: process.env.VUE_APP_FACEBOOK_PIXEL_ID || '',
  hotjarId: process.env.VUE_APP_HOTJAR_ID || ''
};

// Chatwoot live chat configuration
const chatwootConfig = {
  baseUrl: process.env.VUE_APP_CHATWOOT_BASE_URL || 'https://limmekrent.hu:3443',
  websiteToken: process.env.VUE_APP_CHATWOOT_WEBSITE_TOKEN || 'QrZGe1p4qmv3nuSUcqBw2PS8'
};

// Feature flags
const featureFlags = {
  // Gates all stock/period available-quantity checks in cart & checkout
  // (out-of-stock badges, add-to-cart/increment disabling, checkout blocking).
  // Set back to true to re-enable that business logic.
  enforceQuantityAvailability: false
};

export default {
  backendUrl,
  cookieConfig,
  analyticsConfig,
  chatwootConfig,
  featureFlags
};
